import { useContext } from "react";
import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";
import VentanaAsociado from "../../../isp.iu.asociados/reductores/ventanas/VentanaAsociado";
import VentanaQueryAsociados from "../../../isp.iu.asociados/reductores/ventanas/VentanaQueryAsociados";

export default function MenuItemsRRHH(dispatch) {
    const {
        abrirVentana,
    } = useContext(GlobalContext);
    return [
        {
            label: "Nuevo Asociado",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = VentanaAsociado.nuevaVentanaEnModoCrear();
                abrirVentana(nuevaVentana);
            },
        },
        {
            label: "Listar Asociados",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryAsociados();
                abrirVentana(nuevaVentana);
            },
        },
    ];
}

